import { ROLES } from "./consts";

const getUserRoleName = (roles) => {
  let roleName = "";

  for (let role of roles) {
    if (role === ROLES.ROLE_PROJECT || role === ROLES.ROLE_USER) {
      continue;
    }

    const words = role.replace('ROLE_', '').toLowerCase().split('_');

    const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));

    roleName = capitalizedWords.join(' ');
  }

  return roleName;
};

export default getUserRoleName;
